import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { mapState } from 'pinia';
import { getSmoother } from 'utils/ScrollSmootherInstance.js';
import matchMediaConfig from 'utils/matchMedia.js'

gsap.registerPlugin(ScrollTrigger);
import { useScrollStore } from "stores/scroll";
export default {
	data() {
		return {
			isStartAnimation: false
		}
	},
	methods: {
		initAnimations() {
			const mm = gsap.matchMedia()
			mm.add(matchMediaConfig, (context) => {
				const { isDesktop, isMobile } = context.conditions
				context.add(() => {
					const headerHeight = document.querySelector('header').offsetHeight;
					const smoother = getSmoother();

					const markersPoint = document.querySelectorAll('.block-simple6 .marker-round');
					markersPoint.forEach((marker) => {
						gsap.set(marker, { opacity: 0 });
					})

					if (isDesktop) {
						//TODO ANIMATION
						if (this.getScrollEnabled && true) {
							// настройки для автоматического скролла блока вверх
							ScrollTrigger.create({
								trigger: '.block-simple6',
								start: "25% bottom",
								id: "block6",
								// start: this.scrollUpPosition,
								markers: false,
								end: "bottom bottom",
								onEnter: () => {
									if (this.getScrollDirection === 'down') {
										gsap.to(smoother, {
											scrollTop: Math.min(
												ScrollTrigger.maxScroll(window),
												smoother.offset('.block-simple6', `top ${headerHeight}px`)
											),
											duration: 1.2,
											ease: "smoother",
											onStart: () => {
												smoother.smooth(0.1);
												smoother.paused(true)
											},
											onComplete: () => {
												smoother.paused(false)
												smoother.smooth(3);
											}
										});
									}
								},
							});
						}

						ScrollTrigger.create({
							trigger: '.block-simple6',
							start: `top ${headerHeight + 1}px`,
							onEnter: () => {
								markersPoint.forEach((marker) => {
									gsap.to(marker, { delay: 0.001, opacity: 1, duration: 0.6 });
								})
							},
						});
					}

					ScrollTrigger.create({
						trigger: '.map-slider__nav',
						start: "bottom bottom",
						onEnter: () => {
							this.isStartAnimation = true
						},
					});

					if (isMobile) {
						//TODO ANIMATION
						// if (this.getScrollEnabled && true) {
						// 	// настройки для автоматического скролла блока вверх
						// 	ScrollTrigger.create({
						// 		trigger: '.block-simple6',
						// 		start: "25% bottom",
						// 		id: "block6",
						// 		// start: this.scrollUpPosition,
						// 		markers: false,
						// 		end: "bottom bottom",
						// 		onEnter: () => {
						// 			if (this.getScrollDirection === 'down') {
						// 				gsap.to(smoother, {
						// 					scrollTop: Math.min(
						// 						ScrollTrigger.maxScroll(window),
						// 						smoother.offset('.block-simple6', `top ${headerHeight}px`)
						// 					),
						// 					duration: 1.2,
						// 					ease: "smoother",
						// 					onStart: () => {
						// 						smoother.smooth(0.1);
						// 						smoother.paused(true)
						// 					},
						// 					onComplete: () => {
						// 						smoother.paused(false)
						// 						smoother.smooth(3);
						// 					}
						// 				});
						// 			}
						// 		},
						// 	});
						// }

						ScrollTrigger.create({
							trigger: '.block-simple6',
							start: "top top",
							end: "bottom -=100%",
							// pin: true,
							onEnter: () => {
								markersPoint.forEach((marker) => {
									gsap.to(marker, { delay: 0.001, opacity: 1, duration: 0.6 });
								})
							}
						});
					}
				})
			})
		},
		killAnimations() {
			ScrollTrigger.getAll().forEach(trigger => trigger.kill());
		}
	},
	computed: {
		...mapState(usePageAnimationStore, ["getPageCanAnimateBlocks", "getScrollDirection"]),
		...mapState(useScrollStore, ["getScrollEnabled", "scrollUpPosition", "scrollDownPosition"]),
	},

	mounted() {
		this.$nextTick(() => {
			if (this.getPageCanAnimateBlocks) {
				this.initAnimations();
			}
		});
	},
	beforeUnmount() {
		this.killAnimations();
	},
	watch: {
		getPageCanAnimateBlocks(state) {
			if (state) {
				this.initAnimations();
			}
		},
	}
}
